exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width: 780px) {\n  .galery-card,\n  .galery-carousel {\n    width: 100% !important;\n  }\n}\n@media (max-width: 780px) {\n  .galery-carousel-thumb {\n    width: 95px !important;\n    height: 70px !important;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader?paths=gui/css!./ui/c/footer/style.styl
// module id = 854
// module chunks = 0